import type { RootStateType } from '../../store';

export function selectLicense(state: RootStateType) {
  return state.license;
}
